import{createContext as r}from"react";var t=r([!1,function(){return null}]);export{t as PopoverContext};
